import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const SettingsContext = createContext();

const SETTINGS_KEY = "settings";

export const SettingsProvider = ({ children }) => {
    // Immediately load cached settings
    const [settings, setSettings] = useState(() => {
        try {
            const cached = localStorage.getItem(SETTINGS_KEY);

            return cached
                ? JSON.parse(cached).settings
                : null;
        } catch (error) {
            console.error("Failed to load cached settings:", error);
            return null;
        }
    });

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const baseUrl = process.env.REACT_APP_API_URL || "";

                // 1. Get latest version
                const versionResponse = await axios.get(
                    `${baseUrl}/api/settings/version`
                );

                const apiVersion = versionResponse.data.version;

                // Get cached data
                const cached = localStorage.getItem(SETTINGS_KEY);
                const cachedData = cached
                    ? JSON.parse(cached)
                    : null;

                // 2. Version is same → no need to fetch settings
                if (
                    cachedData &&
                    cachedData.version === apiVersion
                ) {
                    return;
                }

                // 3. Version is different → fetch new settings
                const settingsResponse = await axios.get(
                    `${baseUrl}/api/settings`
                );

                const data = settingsResponse.data;

                // 4. Update localStorage
                localStorage.setItem(
                    SETTINGS_KEY,
                    JSON.stringify({
                        version: apiVersion,
                        settings: data.settings
                    })
                );

                // 5. Update React state
                setSettings(data.settings);

            } catch (error) {
                console.error(
                    "Error fetching settings:",
                    error
                );
            }
        };

        fetchSettings();
    }, []);

    return (
        <SettingsContext.Provider value={{ settings }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => useContext(SettingsContext);   